import StudyUK from '../../../assets/img2024_8/British_Council_Cover.jpg';
import FreshCheck from '../../../assets/img2024_8/FreshCheck.png'
import Ifindpal from '../../../assets/img2024_8/Ifindpal.png'
import graduate from '../../../assets/img2024_8/graduate.jpg'
import Dyson from '../../../assets/img2024_8/dyson4.jpg'
import { Carousel } from 'antd';

export default function CarouselX() {
    const contentStyle = {
        margin: '0 auto',
        height: '15rem',
        width: '20rem',
        textAlign: 'center',
        background: '#364d79',
        borderRadius: '1rem',
        opacity: '0.85',

    };

    const contentStyle2 = {
        margin: '0 auto',
        height: '15rem',
        width: '18rem',
        textAlign: 'center',
        background: '#364d79',
        borderRadius: '1rem',
        opacity: '0.85',

    };
    const imgStyle = {
        maxHeight: '100%', // Ensure the image fits the container height
        maxWidth: '100%',  // Ensure the image fits the container width
        borderRadius: '1rem',
    };

    return (
        <>
            <Carousel autoplay>
                <div >
                    <img src={StudyUK} style={contentStyle} />
                </div>
                <div>
                    <img src={Dyson} style={contentStyle} />
                </div>
                <div>
                    <img src={graduate} style={contentStyle2} />
                </div>
                <div>
                    <img src={FreshCheck} style={contentStyle} />
                </div>
                <div>
                    <img src={Ifindpal} style={contentStyle} />
                </div>

            </Carousel>
        </>
    );
}
